import * as React from 'react';
import toast from 'cogo-toast';
import { Redirect } from 'react-router-dom';
import { Page, Grid, Form, Button, Alert } from 'tabler-react';

import Request from '../../shared/request';
import PageComponent from '../PageComponent';
import store from '../../shared/store';

const NO_CAPTCHA = { captcha: '', captchaValue: '', captchaToken: '', captchaError: '' };

class EmailConfirm extends PageComponent {
  state = {
    loading: false,
    sending: false,
    passcode: null,
    countdown: 0,
    email: '',
    captcha: '',
    captchaValue: '',
    captchaToken: '',
    captchaError: '',
  };

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  confirm = async event => {
    event.preventDefault();
    if (!this.state.passcode) {
      toast.warn('请输入验证码');
      return;
    }
    if (this.state.loading) return;
    this.setState({ loading: true });
    const res = await Request.call('confirmUserEmail', {
      passcode: this.state.passcode,
      uid: store.user.uid,
    });
    this.setState({ loading: false });
    if (res) {
      toast.success('确认成功');
      store.updateUser();
    }
  };

  sendCode = () => this.requestPasscode();

  requestPasscode = async captchaBody => {
    if (this.state.sending) return;
    if (this.state.email !== store.user.email) {
      toast.warn('输入邮箱与登录邮箱不匹配');
      return;
    }
    this.setState({ sending: true });
    const res = await Request.call('sendPasscode', {
      type: 'email',
      from: 'CONFIRM_EMAIL',
      email: store.user.email,
      ...captchaBody,
    });
    if (res && res.code === 11138) {
      this.setState({
        sending: false,
        captcha: res.data.captcha,
        captchaToken: res.data.captchaToken,
        captchaValue: '',
        captchaError: captchaBody ? res.message : '',
      });
      return;
    }
    // 其他失败 Request 已 toast，必须关弹层，否则 toast 被遮罩压住
    this.setState({ sending: false, ...NO_CAPTCHA });
    if (res) {
      this.createTimer();
      toast.success('发送成功');
    }
  };

  resetCaptcha = () => this.setState(NO_CAPTCHA);

  closeCaptcha = () => {
    if (this.state.sending) return;
    this.resetCaptcha();
  };

  refreshCaptcha = () => this.requestPasscode();

  submitCaptcha = event => {
    event.preventDefault();
    const captchaValue = this.state.captchaValue.trim();
    if (!captchaValue) {
      toast.warn('请输入安全码');
      return;
    }
    this.requestPasscode({ captcha: captchaValue, captchaToken: this.state.captchaToken });
  };

  createTimer = () => {
    if (!this.state.countdown) {
      this.setState({ countdown: 60 });
      this.timer = setInterval(() => {
        if (this.state.countdown <= 1) {
          clearInterval(this.timer);
        }
        this.setState(prev => ({ countdown: prev.countdown - 1 }));
      }, 1000);
    }
  };

  render() {
    if (store.user.status === 'OK') return <Redirect to="/dashboard" />;

    return (
      <Grid.Row className="malus-setting">
        <Grid.Col xl={6} offsetXl={3} lg={6} offsetLg={3}>
          <Page.Card title="确认邮箱">
            <Alert type="success">
              确认邮箱即可获得VIP试用，请到邮箱查收验证码，如果没有请查看Spam/垃圾箱。
            </Alert>

              <Form.InputGroup
                append={
                  <Button
                    RootComponent="button"
                    type="button"
                    disabled={this.state.sending || this.state.countdown}
                    onClick={this.sendCode}>
                    {this.state.countdown ? `过${this.state.countdown}秒重发` : '发送验证码'}
                  </Button>
                }>
                <Form.Input
                  onChange={e => this.setState({ email: e.target.value })}
                  placeholder="请输入帐号邮箱"
                  autoComplete="off"
                />
              </Form.InputGroup>
              <div style={{ marginTop: '10px' }}>
                <Form.Input
                  onChange={e => this.setState({ passcode: e.target.value })}
                  placeholder="请输入邮箱验证码"
                  autoComplete="off"
                />
                </div>
              <Button
                onClick={this.confirm}
                className="malus-setting-btn"
                disabled={this.state.loading}
                loading={this.state.loading}
                color="primary">
                确认
              </Button>
            {this.state.captcha ? (
              <div className="captcha">
                <div className="content">
                  <div className="header">
                    <div className="title">安全验证</div>
                    <i className="ri-close-circle-line" onClick={this.closeCaptcha} />
                  </div>
                  <form className="body" onSubmit={this.submitCaptcha}>
                    <img
                      src={`data:image/png;base64,${this.state.captcha}`}
                      onClick={this.refreshCaptcha}
                      title="看不清？点击图片刷新"
                      alt="code"
                    />
                    <Form.Input
                      key={this.state.captchaToken}
                      onChange={e => this.setState({ captchaValue: e.target.value })}
                      type="text"
                      autoComplete="off"
                      autoFocus
                      disabled={this.state.sending}
                      value={this.state.captchaValue}
                      error={this.state.captchaError}
                      placeholder="请输入安全码"
                    />
                    <Button
                      className="malus-setting-btn"
                      type="submit"
                      color="primary"
                      loading={this.state.sending}
                      disabled={this.state.sending}>
                      完成验证
                    </Button>
                  </form>
                </div>
              </div>
            ) : null}
          </Page.Card>
        </Grid.Col>
      </Grid.Row>
    );
  }
}

export default EmailConfirm;
